"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasetItemMediaFields = void 0;
/**
 * Dataset item fields that can hold media references. Stored as the
 * `dataset_item_media.field` column value and exposed on the public API.
 */
exports.datasetItemMediaFields = [
    "input",
    "expectedOutput",
    "metadata",
];
